module.exports = __webpack_public_path__ + "static/media/icons.68888b33.svg";